/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	var $window = $(window);
	
	// preload
	
	(0, _module.preload)();
	
	// resizing
	
	(0, _module.resizing)();
	
	//ページ内リンクのアニメーション
	
	(0, _module.anchorScroll)();
	
	//ヘッダー開閉
	
	(0, _module.headerToggle)();
	
	$(window).on('load', function () {
	  setTimeout(function () {
	    (0, _module.scrollAnimation)();
	  }, 100);
	});
	
	$(window).on('scroll', function () {
	  (0, _module.scrollAnimation)();
	});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $window = $(window);
	var breakPoint = 768;
	
	var resizeFlag = false;
	var windowWidth = $window.width();
	var windowHeight = $window.height();
	//const bodyLimitHeight = (windowHeight - 185) * 0.88;
	
	var url = location.href;
	
	// preload
	var preload = function preload() {
	  var timer = 0;
	  $(window).on('load', function () {
	    if (timer > 0) {
	      clearTimeout(timer);
	    }
	    timer = setTimeout(function () {
	      $("body").removeClass("preload");
	    }, 100);
	  });
	};
	
	// resizing
	var resizing = function resizing() {
	  var timer = 0;
	  $(window).on('resize', function () {
	    var resizeWidth = $window.width();
	    if (windowWidth !== resizeWidth) {
	      $("body").addClass("resizing");
	      if (timer > 0) {
	        clearTimeout(timer);
	      }
	      timer = setTimeout(function () {
	        $("body").removeClass("resizing");
	      }, 100);
	    }
	    windowWidth = resizeWidth;
	  });
	};
	
	//ページ内リンクのアニメーション
	var anchorScroll = function anchorScroll() {
	  var $anchor = $('a[href^=#]');
	  $anchor.click(function () {
	    var speed = 1000;
	    var href = $(this).attr('href');
	    var target = $(href == '#' || href == '' ? 'html' : href);
	    var position = target.offset().top;
	    $('html, body').animate({
	      scrollTop: position
	    }, speed, 'swing');
	    return false;
	  });
	};
	
	// ------------------------------------------------------------------------
	// js-Animation
	// ------------------------------------------------------------------------
	var scrollAnimation = function scrollAnimation() {
	  var winScroll = $(window).scrollTop();
	  var winHeight = $(window).height();
	  // js-Animation
	  $('.js-Animation').each(function () {
	    var target = $(this);
	    if (windowWidth > breakPoint) {
	      if (target.offset().top < winScroll + winHeight * .9) {
	        target.addClass('animated');
	      }
	    } else {
	      if (target.offset().top < winScroll + winHeight * .9) {
	        target.addClass('animated');
	      }
	    }
	  });
	};
	
	// ------------------------------------------------------------------------
	// headerToggle
	// ------------------------------------------------------------------------
	var headerToggle = function headerToggle() {
	  var $header = $('.st-Header');
	  var $header_btn = $('.st-Header .st-Header_Hamburger');
	  var $header_link = $('.st-Header a[href^=#]');
	  $header_btn.on('click', function () {
	    $header.toggleClass('active');
	    $('body').toggleClass('noscrollBar');
	  });
	  $header_link.click(function () {
	    $header.removeClass('active');
	    $('body').removeClass('noscrollBar');
	    return false;
	  });
	};
	
	/*-------------------------------------------------------------------*/
	/* movieモーダル */
	/*-------------------------------------------------------------------*/
	// playAudio
	var playAudio = function playAudio() {
	  // 再生ボタンの取得
	  var audio = $('.js-Audio');
	  // 曲のソース
	  var list = ["/assets/audio/morning.mp3", "/assets/audio/koino-bang.mp3"];
	  var sound = [audio.length];
	  var current = void 0;
	  for (var i = 0; i < audio.length; i++) {
	    sound[i] = new Howl({
	      src: [list[i]],
	      preload: true,
	      autoplay: false,
	      onend: function onend() {
	        onEnd();
	      }
	    });
	  }
	  // 曲が終わった際の処理
	  function onEnd() {
	    if ($(audio[current]).hasClass('current')) {
	      $(audio[current]).removeClass('current');
	    }
	  }
	
	  // クリックイベント
	  $('body').on('click', '.js-Audio', function () {
	    // 押されたボタンが何番目か判定
	    current = $('.js-Audio').index(this);
	    for (var _i = 0; _i < audio.length; _i++) {
	      if (current != _i) {
	        sound[_i].stop();
	        if ($(audio[_i]).hasClass('current')) {
	          $(audio[_i]).removeClass('current');
	        }
	      } else {
	        if ($(this).hasClass('current')) {
	          sound[current].pause();
	          $(this).removeClass('current');
	        } else {
	          $(this).addClass('current');
	          sound[current].play();
	        }
	      }
	    }
	  });
	
	  // 動画を表示した際に音楽を停止する処理
	  $('body').on('click', '.js-Youtube', function () {
	    for (var _i2 = 0; _i2 < audio.length; _i2++) {
	      sound[_i2].stop();
	      if ($(audio[_i2]).hasClass('current')) {
	        $(audio[_i2]).removeClass('current');
	      }
	    }
	  });
	
	  document.addEventListener('visibilitychange', function () {
	    if (document.visibilityState === 'hidden') {
	      for (var _i3 = 0; _i3 < audio.length; _i3++) {
	        sound[_i3].stop();
	        if ($(audio[_i3]).hasClass('current')) {
	          $(audio[_i3]).removeClass('current');
	        }
	      }
	    }
	  }, false);
	};
	
	/*-------------------------------------------------------------------*/
	/* movieモーダル */
	/*-------------------------------------------------------------------*/
	// movie
	var showMovie = function showMovie() {
	  var $modal = $('#movie-Stage');
	  var $content = $('#movie-Iframe');
	
	  var openMovie = function openMovie(data) {
	    $('#movie-Stage').css({ 'opacity': '0', 'display': 'block' }).stop().animate({ 'opacity': '1', 'width': 100 + '%', 'height': 100 + 'vh', 'top': 0, 'left': 0 }, 300, 'easeOutQuart', function () {
	      //iframe append
	      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/' + data + '?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>');
	      // // fadeIn
	      // $modal.stop().fadeIn(400);
	      return false;
	    });
	  };
	
	  var keyName = 'visited';
	  var keyValue = true;
	
	  if ($('body').hasClass('home')) {
	    if (!sessionStorage.getItem(keyName)) {
	      //sessionStorageにキーと値を追加
	      sessionStorage.setItem(keyName, keyValue);
	      //ここに初回アクセス時の処理
	      setTimeout(function () {
	        var data = $('#show').attr('data-youtube');
	        openMovie(data);
	      }, 100);
	    }
	  }
	
	  // クリックでの表示
	  $('body').on('click', '.js-Youtube', function () {
	    var data = $(this).attr('data-youtube');
	    openMovie(data);
	    $('body').css({ 'overflow': 'hidden' });
	  });
	
	  //close
	  $('#movie-Close,#movie-Iframe').on('click', function () {
	    $('body').css({ 'overflow': 'auto' });
	    $('#movie-Stage').css({ 'opacity': '1' }).stop().animate({ 'opacity': '0' }, 300, 'easeOutQuart', function () {
	      $('#movie-Stage').css({ 'display': 'none' });
	      $content.children('iframe').remove();
	    });
	  });
	};
	/*-------------------------------------------------------------------*/
	/* discographyモーダル */
	/*-------------------------------------------------------------------*/
	var shop_modal = function shop_modal() {
	  var $modal = $('#shop_modal');
	  // const $content = $('#movie-Iframe');
	
	  var openShop = function openShop() {
	    $('#shop_modal').css({ 'opacity': '0', 'display': 'block' }).stop().animate({ 'opacity': '1', 'width': 100 + '%', 'height': 100 + 'vh', 'top': 0, 'left': 0 }, 300, 'easeOutQuart');
	  };
	
	  // クリックでの表示
	  $('body').on('click', '#shop', function () {
	    $('body').css({ 'overflow': 'hidden' });
	    openShop();
	  });
	
	  //close
	  $('#shop_modal #shop_modal_Overlay, #shop_modal #btn').on('click', function () {
	    $('body').css({ 'overflow': 'auto' });
	    $('#shop_modal').css({ 'opacity': '1' }).stop().animate({ 'opacity': '0' }, 300, 'easeOutQuart', function () {
	      $('#shop_modal').css({ 'display': 'none' });
	    });
	  });
	};
	
	/*-------------------------------------------------------------------*/
	/* profileモーダル */
	/*-------------------------------------------------------------------*/
	// profile
	var showprofile = function showprofile() {
	  var $modal = $('#profile-Stage');
	
	  // open
	  $('body').on('click', '.js-Profile', function () {
	
	    var dataID = $(this).attr('data-id');
	    var dataROLE = $(this).attr('data-role');
	    $('body').addClass('noscrollBar');
	
	    $('#profile-Content').children('div.' + dataID).css({ 'display': 'block' });
	    $('#profile-Inner').children('span.' + dataROLE).css({ 'display': 'inline-block' });
	    $('#profile-Stage').css({ 'opacity': '0', 'display': 'block' }).stop().animate({ 'opacity': '1', 'width': 100 + '%', 'height': 100 + 'vh', 'top': 0, 'left': 0 }, 300, 'easeOutQuart', function () {
	      return false;
	    });
	    $('#profile-Inner').addClass('active');
	  });
	
	  //close
	  $('#profile-Close,#profile-Close_bottom,#profile-Overlay,#profile-Btn').on('click', function () {
	    $('body').removeClass('noscrollBar');
	    $('#profile-Stage').css({ 'opacity': '1' }).stop().animate({ 'opacity': '0' }, 300, 'easeOutQuart', function () {
	      $('#profile-Stage').css({ 'display': 'none' });
	      $('#profile-Content').children('div').css({ 'display': 'none' });
	      $('#profile-Inner').children('span').css({ 'display': 'none' });
	    });
	    $('#profile-Inner').removeClass('active');
	  });
	};
	// showprofile();
	
	//export
	exports.preload = preload;
	exports.resizing = resizing;
	exports.anchorScroll = anchorScroll;
	exports.scrollAnimation = scrollAnimation;
	exports.showMovie = showMovie;
	exports.showprofile = showprofile;
	exports.playAudio = playAudio;
	exports.headerToggle = headerToggle;
	exports.shop_modal = shop_modal;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// event/app.bundle.js